import { render, staticRenderFns } from "./generate-codes.vue?vue&type=template&id=4242dc8c&scoped=true&"
import script from "./generate-codes.vue?vue&type=script&lang=js&"
export * from "./generate-codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242dc8c",
  null
  
)

export default component.exports